import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

type Props = {
    className?: string;
    mobile?: boolean;
    number: number;
};

export const StepNumber = ({ className, mobile = false, number }: Props) => (
    <span
        aria-hidden
        className={cn(
            'flex h-[128px] w-[54px] items-center justify-center',
            {
                'h-[128px] w-[54px]': !mobile,
                'h-[48px] w-[20px]': mobile,
            },
            className
        )}
    >
        <span
            className={cn(
                'block font-bold leading-none text-text-primary opacity-30',
                {
                    'ml-[24px]': !mobile,
                    'text-[170px]': !mobile,
                    'text-[64px]': mobile,
                },
                '[transform:scaleX(0.9)]'
            )}
        >
            {number}
        </span>
    </span>
);
